<template>
    <div>
        <Form>
            <Row :gutter="20">
                <Col span="10">
                    <FormItem label="房源：" prop="houseName">
                        <span>{{ houseName }}</span>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="期数：" prop="totalPeriod">
                        <span>{{ totalPeriod }}</span>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem label="客户：" prop="cusName">
                        <span>{{ cusName }}</span>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem label="手机号：" prop="cusMobile">
                        <span>{{ cusMobile }}</span>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <Select
                style="width: 130px; margin-right: 20px"
                v-model="filter.notifyType"
                placeholder="提醒类型"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in notifyTypeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 130px; margin-right: 20px"
                v-model="filter.sendStatus"
                placeholder="提醒发送"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in sendStatusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:sendStatusText="{ row }">
                <tag-status
                    :text="row.sendStatusText"
                    :color="row.sendStatusColor"
                    circle
                />
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            transfer
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
    </div>
</template>

<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency } from '_u/helper'
import dayjs from 'dayjs'
import Dict from '_u/dict'
import RemindRecordForm from './remind-record-form'
import { notifyList } from '@/api/tenants'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import TagStatus from '_vc/tag-status'
import FilterDateRange from '_v/components/filter/filter-date-range'

const PAGE_SIZE = 20

export default {
    name: 'remind-record-form',

    components: { RemindRecordForm, TagStatus, FilterDateRange },
    props: {
        cusId: {
            type: [String, Number],
            default: '',
        },
        houseId: {
            type: [String, Number],
            default: '',
        },
        cusName: {
            type: [String, Number],
            default: '',
        },
        cusMobile: {
            type: [String, Number],
            default: '',
        },
        houseName: {
            type: [String, Number],
            default: '',
        },
        totalPeriod: {
            type: [String, Number],
            default: '',
        },
    },

    data() {
        return {
            mtHeight: 330,
            loading: false,
            curId: '',
            info: {
                cusMobile: this.cusMobile,
            },
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                cusId: this.cusId,
                houseId: this.houseId,
                notifyType: '',
                sendStatus: '',
                startDate: '',
                endDate: '',
            },
            page: {
                total: 0,
                list: [],
            },

            dict: {
                notifyType: Dict.NULL,
                sendStatus: Dict.NULL,
            },
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 80,
                },
                {
                    key: 'createTime',
                    title: '提醒时间',
                    align: 'center',
                    minWidth: 150,
                    tooltip: true,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'periodText',
                    title: '提醒账期',
                    align: 'center',
                    minWidth: 200,
                },
                {
                    key: 'notifyDataSource',
                    title: '提醒类型',
                    align: 'center',
                    minWidth: 160,
                    tooltip: true,
                    render: mapCell(this.dict.notifyType.toList()),
                },
                {
                    key: 'sendStatusText',
                    title: '提醒发送状态',
                    align: 'center',
                    minWidth: 150,
                    slot: 'sendStatusText',
                },
            ]
        },

        notifyTypeList() {
            return this.dict.notifyType.toList()
        },
        sendStatusList() {
            return this.dict.sendStatus.toList()
        },
    },
    created() {
        this.fetch()
    },
    mounted() {},
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                Dict.get(['notify_type', 'send_status']),
                notifyList(this.filter),
            ])
                .then((args) => {
                    var [dictGroup, notify] = args
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.setData(notify.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setData(data) {
            const sendStatusDict = this.dict.sendStatus
            data.page.list.forEach((v) => {
                v.periodText = `第${v.period}期(${v.startDate} 至 ${v.endDate})`
                const sendStatus = sendStatusDict.get(v.sendStatus)
                v.sendStatusText = sendStatus.text
                v.sendStatusColor = JSON.parse(sendStatus.remark).color
                v.sendStatusBgc = JSON.parse(sendStatus.remark).background
            })
            this.page.list = data.page.list
            this.page.totalCount = parseInt(data.page.totalCount)
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
    },
}
</script>
<style lang="less" scoped></style>
